"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchoolGuaranteeTemplate = void 0;
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const typedi_1 = require("typedi");
const translation_1 = require("@translation/services/translation");
/**
 * Всплывающее окно
 */
let SchoolGuaranteePopup = class SchoolGuaranteePopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body pt-0">
                            <div class="mb-5">
                                <h2>${this.translationService.instant('community_program_guarantee_title_1')}</h2>

                                <h2>${this.translationService.instant('community_program_guarantee_title_2')}</h2>
                                <p>${this.translationService.instant('community_program_guarantee_text_3')}</p>
                                
                                <p><b>${this.translationService.instant('community_program_guarantee_text_4_1')}</b>${this.translationService.instant('community_program_guarantee_text_4_2')}</p>
                                <ul>
                                    <li>${this.translationService.instant('community_program_guarantee_list_5_1')}</li>
                                    <li>${this.translationService.instant('community_program_guarantee_list_5_2')}</li>
                                    <li>${this.translationService.instant('community_program_guarantee_list_5_3')}</li>
                                    <li>${this.translationService.instant('community_program_guarantee_list_5_4')}</li>
                                </ul>
                                
                                <p><b>${this.translationService.instant('community_program_guarantee_text_6_1')}</b>${this.translationService.instant('community_program_guarantee_text_6_2')}</p>
                                <ul>
                                    <li><b>${this.translationService.instant('community_program_guarantee_list_7_1_1')}</b>
                                        <br />${this.translationService.instant('community_program_guarantee_list_7_1_2')}
                                    </li>
                                    <li><b>${this.translationService.instant('community_program_guarantee_list_7_2')}</b></li>
                                    <li><b>${this.translationService.instant('community_program_guarantee_list_7_3_1')}</b>
                                        <br />${this.translationService.instant('community_program_guarantee_list_7_3_2')}
                                    </li>
                                    <li><b>${this.translationService.instant('community_program_guarantee_list_7_4_1')}</b>
                                        <br />${this.translationService.instant('community_program_guarantee_list_7_4_2')}
                                        <b>${this.translationService.instant('community_program_guarantee_list_7_4_3')}</b>
                                    </li>
                                </ul>
                                
                                <p><b>${this.translationService.instant('community_program_guarantee_text_8_1')}</b> ${this.translationService.instant('community_program_guarantee_text_8_2')}</p>
                                <ul>
                                    <li><b>${this.translationService.instant('community_program_guarantee_list_9_1_1')}</b>
                                    <br/>${this.translationService.instant('community_program_guarantee_list_9_1_2')}
                                    </li>
                                    <li>${this.translationService.instant('community_program_guarantee_list_9_2')}</li>
                                    <li>${this.translationService.instant('community_program_guarantee_list_9_3')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
};
SchoolGuaranteePopup = __decorate([
    (0, decorators_js_1.customElement)('art-school-guarantee-popup'),
    __metadata("design:paramtypes", [])
], SchoolGuaranteePopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getSchoolGuaranteeTemplate() {
    return (0, lit_html_1.html) `<art-school-guarantee-popup></art-school-guarantee-popup>`;
}
exports.getSchoolGuaranteeTemplate = getSchoolGuaranteeTemplate;
window.PopupController.registerTemplate('school-guarantee', getSchoolGuaranteeTemplate);
